export default "__VITE_ASSET__CTUaCgsX__"